const cartItem = {
  apiCdrFlex: {
    label: "Flex",
  },
  apiKeyFlex: {
    label: "Clé API",
  },
  apiCdrAlphalink: {
    label: "Alphalink",
  },
  apiKeyAlphalink: {
    label: "Clé API",
  },
  apiOriginCdrAlphalink: {
    label: "Origin CDR",
    options: {
      alphalink: "Alphalink",
      orange: "Orange",
    }
  },
  apiCdrTransatel: {
    label: "Transatel",
  },
  apiKeyTransatel: {
    label: "Clé API",
  },
  apiOriginCdrTransatel: {
    label: "Origin CDR",
    options: {
      orange: "Orange",
    }
  },
  apiCdrTelcoz: {
    label: "Telcoz",
  },
  apiKeyTelcoz: {
    label: "Clé API",
  },
  apiCdrFile: {
    label: "Autre",
  },
  apiKeyFile: {
    label: "Clé API",
  },
};

export default cartItem;
